import { cn } from '@april9au/react-common/utils';

/**
 * The screen's primary action, where a thumb can reach it.
 *
 * On a phone the one thing to tap belongs at the bottom of the viewport, not
 * wherever the content happens to end — a learner should never scroll to find
 * it. Below `sm` this pins itself to the bottom edge over the page's own navy,
 * blurred; from `sm` up there is no reach problem, so it drops back into the
 * flow and stops being chrome. All of that lives in the `.action-bar` class in
 * `app.css`.
 *
 * `position: sticky`, not `fixed`: the bar takes part in layout, so it cannot
 * shift anything when it appears and it settles naturally at the end of a short
 * page.
 *
 * Put it inside a page's `<main>`, which must be a **flex column**: the class
 * sets `margin-block-start: auto`, so on a page shorter than the viewport the
 * bar is pushed to the bottom edge instead of sitting halfway down under the
 * content. The `-1.25rem` inline margin that lets it bleed to the edge of the
 * screen is measured from that same `<main>`.
 *
 * Render it **last** in the page: anything after it in the DOM appears below
 * the bar, which is not where a secondary link belongs.
 */
export function ActionBar({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={cn('action-bar', className)}>{children}</div>;
}
